const selectMessages = state => state.ui.messages.items

const MessageSelectors = {
  messages: selectMessages
}

export default MessageSelectors
